import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import Tooltip from '../../../../ui/tooltips/Tooltip'

import { ReactComponent as PLAY_ICON } from '../../../../../assets/svg/actions/icn-play-16px.svg'
import { ReactComponent as LINE_CHART_ICON } from '../../../../../assets/svg/actions/icn-line-chart-16px.svg'
import { ReactComponent as SHARE_ICON } from '../../../../../assets/svg/actions/icn-share-16px.svg'
import { ReactComponent as DOWNLOAD_ICON } from '../../../../../assets/svg/actions/icn-download-16px.svg'

const RowCard = ({
    id,
    title,
    actions
}) => {
    const [activeBtn, setActiveBtn] = useState('');

    return (
        <div className="row-card">
            <div className="row-card-left">{title}</div>
            <div className="row-card-right">
                <Tooltip text="Play">
                    <Button variant="tertiary" active={activeBtn === `video-${id}`} onClick={() => {setActiveBtn(`video-${id}`); actions.video(id)}}>
                        <PLAY_ICON className="row-card-icon" alt="Play" />
                    </Button>
                </Tooltip>
                <Tooltip text="Statistics">
                    <Button variant="tertiary" active={activeBtn === `statistics-${id}`} onClick={() => {setActiveBtn(`statistics-${id}`); actions.statistics(id)}}>
                        <LINE_CHART_ICON className="row-card-icon" alt="statistics" />
                    </Button>
                </Tooltip>
                <Tooltip text="Share">
                    <Button variant="tertiary" active={activeBtn === `share-${id}`} onClick={() => {setActiveBtn(`share-${id}`); actions.share(id)}}>
                        <SHARE_ICON className="row-card-icon" alt="Share" />
                    </Button>
                </Tooltip>
                <Tooltip text="Download">
                    <Button variant="tertiary" active={activeBtn === `download-${id}`} onClick={() => {setActiveBtn(`download-${id}`); actions.download(id)}}>
                        <DOWNLOAD_ICON className="row-card-icon" alt="Download" />
                    </Button>
                </Tooltip>
            </div>
        </div>
    )
}

RowCard.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    actions: PropTypes.objectOf({
        video: PropTypes.func,
        statistics: PropTypes.func,
        share: PropTypes.func,
        download: PropTypes.func
    })
}

export default RowCard
